module.exports = __webpack_public_path__ + "static/media/REW_About.a1ff2286.jpg";